(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestController', BatteryTestController);

    BatteryTestController.$inject = ['$scope', '$state', 'BatteryTest', 'BatteryTestSearch'];

    function BatteryTestController ($scope, $state, BatteryTest, BatteryTestSearch) {
        var vm = this;
        vm.batteryTests = [];
        vm.loadAll = function() {
            BatteryTest.query(function(result) {
                vm.batteryTests = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            BatteryTestSearch.query({query: vm.searchQuery}, function(result) {
                vm.batteryTests = result;
            });
        };
        vm.loadAll();
        
    }
})();
